import { ExclamationCircleOutlined } from '@ant-design/icons';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 912px;
  height: 328px;
  margin: 0 auto;
`;

export const Icon = styled(ExclamationCircleOutlined)`
  font-size: 48px;
  color: #ff4d4f;
  margin-bottom: 12px;
`;

export const Title = styled.h3`
  font-size: 1.25rem;
  font-weight: 700;
  line-height: 24px;
  text-align: center;
  color: #464646;
`;

export const Message = styled.p`
  font-size: 0.875rem;
  line-height: 20px;
  text-align: center;
  font-weight: 400;
  color: #989898;
`;
